import { _t } from '@/i18n/t';

interface PastDueBannerProps {
  isProcessing: boolean;
  /** True when the server surfaced a hosted invoice URL to retry payment on.
   *  When false, only the "update payment method" action is shown. */
  canRetryPayment: boolean;
  onRetryPayment: () => void;
  onUpdatePayment: () => void;
}

const PastDueBanner = ({
  isProcessing,
  canRetryPayment,
  onRetryPayment,
  onUpdatePayment,
}: PastDueBannerProps) => (
  <div className="border border-red-200 bg-red-50 rounded-md px-6 py-4 flex flex-wrap items-center justify-between gap-3 mb-6">
    <div className="flex flex-col">
      <span className="text-sm font-semibold text-red-800">
        {_t('settings.subscription.banner.title')}
      </span>
      <p className="text-xs text-red-700 m-0 mt-0.5">
        {_t('settings.subscription.banner.description')}
      </p>
    </div>
    <div className="flex items-center gap-3">
      {canRetryPayment && (
        <button
          data-th-button="true"
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-red-600 bg-transparent px-4 py-2 text-sm font-medium text-red-700 transition-colors hover:bg-red-100 disabled:pointer-events-none disabled:opacity-50"
          disabled={isProcessing}
          onClick={onRetryPayment}
        >
          {_t('settings.subscription.banner.retry')}
        </button>
      )}
      <button
        data-th-button="true"
        className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:pointer-events-none disabled:opacity-50"
        disabled={isProcessing}
        onClick={onUpdatePayment}
      >
        {isProcessing
          ? _t('settings.subscription.processing')
          : _t('settings.subscription.banner.action')}
      </button>
    </div>
  </div>
);

export default PastDueBanner;